/**
 *  @class
 *  @function SocialShare
 */
if (!customElements.get('social-share')) {
  class SocialShare extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.links = document.querySelectorAll('.social:not(.clipboard):not(.whatsapp)');
      this.clipboard = this.querySelector('.clipboard');

      this.setupEventListeners();
    }

    setupEventListeners() {
      this.links.forEach((link) => {
        link.addEventListener('click', (event) => {
          let left = (screen.width / 2) - (640 / 2),
            top = (screen.height / 2) - (440 / 2) - 100;
          window.open(link.getAttribute('href'), 'mywin', 'left=' + left + ',top=' + top + ',width=640,height=440,toolbar=0');
          event.preventDefault();
        });
      });
      if (this.clipboard) {
        this.clipboard.addEventListener('click', this.copyLink.bind(this));
      }
    }

    // Copies the shared page's address and shows the "Copied" bubble for 2s.
    // The Clipboard API is missing on insecure origins and can be refused,
    // as in a frame without clipboard-write permission (the theme editor):
    // then the address is copied from a selected textarea instead.
    copyLink() {
      const url = this.shareUrl();
      const write = navigator.clipboard && navigator.clipboard.writeText ?
        navigator.clipboard.writeText(url) :
        Promise.reject(new Error('Clipboard API unavailable'));

      write.catch(() => {
        if (!this.copyFromTextarea(url)) {
          throw new Error('Copy to clipboard failed');
        }
      }).then(() => {
        this.showCopied();
      }, () => {});
    }

    // The permalink the markup gives (data-url) rather than the page's own
    // address, which is another page's when the share block sits in a quick
    // view or a featured product. On the shared product's own page the
    // variant chosen there (?variant=) is kept.
    shareUrl() {
      if (!this.dataset.url) {
        return window.location.href;
      }
      const url = new URL(this.dataset.url, window.location.href),
        variant = new URLSearchParams(window.location.search).get('variant'),
        handle = (path) => path.replace(/\/+$/, '').split('/').pop();

      if (variant && handle(window.location.pathname) === handle(url.pathname)) {
        url.searchParams.set('variant', variant);
      }
      return url.href;
    }

    // Inside this element, so a dialog's focus trap leaves it the focus.
    copyFromTextarea(text) {
      const active = document.activeElement,
        textarea = document.createElement('textarea');
      let copied = false;

      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.setAttribute('aria-hidden', 'true');
      textarea.tabIndex = -1;
      // 12pt keeps iOS from zooming in on the focused field.
      textarea.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;padding:0;border:0;font-size:12pt;opacity:0;pointer-events:none;';
      this.appendChild(textarea);
      textarea.focus({ preventScroll: true });
      textarea.select();
      textarea.setSelectionRange(0, text.length);
      try {
        copied = document.execCommand('copy');
      } catch (error) {
        copied = false;
      }
      textarea.remove();
      if (active && active.focus) {
        active.focus({ preventScroll: true });
      }
      return copied;
    }

    showCopied() {
      clearTimeout(this.copiedTimer);
      this.clipboard.classList.add('clipboard-success');
      this.copiedTimer = setTimeout(() => {
        this.clipboard.classList.remove('clipboard-success');
      }, 2000);
    }
  }
  customElements.define('social-share', SocialShare);
}
